import React from "react";
import {Field} from "react-final-form";
import Error from "./Error";
import PropTypes from "prop-types"

const FieldPrefixContext = React.createContext();

export const FieldPrefix = ({ prefix, children }) => (
    <FieldPrefixContext.Provider value={prefix}>
        {children}
    </FieldPrefixContext.Provider>
);
FieldPrefix.propTypes = {
    prefix: PropTypes.string.isRequired,
}

export const PrefixedField = ({ name, ...props }) => (
    <FieldPrefixContext.Consumer>
        {prefix => <Field name={prefix ? `${prefix}.${name}` : name} {...props} />}
    </FieldPrefixContext.Consumer>
);
PrefixedField.propTypes = {
    name: PropTypes.string.isRequired,
    component: PropTypes.any.isRequired,
}

export const PrefixedError = ({name, ...props}) => {
    return <FieldPrefixContext.Consumer>
        {prefix => <Error name={prefix ? `${prefix}.${name}` : name} {...props} />}
    </FieldPrefixContext.Consumer>
}
PrefixedError.propTypes = {
    name: PropTypes.string.isRequired,
}